/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dealclosed_Tag2Inputs */

const en_coinvestments_dealclosed_tag2 = /** @type {(inputs: Coinvestments_Dealclosed_Tag2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Coinvestments_Dealclosed_Tag2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dealclosed_tag2 = /** @type {((inputs?: Coinvestments_Dealclosed_Tag2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dealclosed_Tag2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dealclosed_tag2(inputs)
});
export { coinvestments_dealclosed_tag2 as "coInvestments_dealClosed_tag" }